import React, { useState, useEffect } from 'react';
import { getMediaUrl, getAuthenticatedImageUrl, DEFAULT_FALLBACK_IMAGE } from '../utils/imageUtils';

function Image({
  src,
  alt = "Image Name",
  className = "",
  useAuth = true, // Whether to use authenticated URL (default: true)
  normalizeUrl = true, // Whether to normalize the URL (default: true)
  fallback = DEFAULT_FALLBACK_IMAGE,
  ...props
}) {
  const [imageSrc, setImageSrc] = useState('');
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!src) {
      setImageSrc(fallback);
      setHasError(false);
      setIsLoading(false);
      return;
    }

    // Reset error state when src changes
    setHasError(false);
    setIsLoading(true);

    // Normalize URL if needed
    let processedSrc = src;
    if (normalizeUrl) {
      processedSrc = getMediaUrl(src);
    }

    // Use authenticated URL if needed
    if (useAuth && processedSrc) {
      processedSrc = getAuthenticatedImageUrl(src);
    }

    setImageSrc(processedSrc || fallback);
  }, [src, useAuth, normalizeUrl, fallback]);

  const handleError = (e) => {
    if (!hasError && imageSrc !== fallback) {
      setHasError(true);
      setImageSrc(fallback);
      setIsLoading(false);
    } else {
      // If fallback also fails, hide the image
      e.target.style.display = 'none';
    }
  };

  const handleLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
      style={{
        ...(isLoading ? { opacity: 0 } : { opacity: 1 }),
        transition: 'opacity 0.3s ease-in-out',
        ...props.style
      }}
      {...props}
    />
  );
}

export default Image;
